<style>
.messaggio-notifica {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
  width: 100%;
}

.bottoni-notifica {
  display: flex;
  flex-direction: row;
  grid-column-gap: 10px;
}

.dettaglio{
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.confirm {
  background-color: #059669 !important;
  border-color: #059669 !important;
}

.reject {
  background-color: var(--bs-primary) !important;
  border-color: var(--bs-primary) !important;
}

.p-datatable-column-header-content {
  font-size: 14px !important;
}

.p-datatable-table-container p {
  margin: 0 !important;
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.text-xl.font-bold {
  font-size: 24px;
  font-weight: bold;
}
</style>

<template>
  <DataTable v-if="loaded" :value="notifiche" tableStyle="min-width: 50rem">
    <template #header>
      <div class="row">
        <div class="col-9"><span class="text-xl font-bold">Notifiche</span></div>
        <div class="col-3 justify-content-end" style="text-align: right; grid-column-gap: 10px">
          <CustomButton title="Visualizza tutte le notifiche" @click="viewAllNotifiche" icon="pi pi-eye" rounded raised style="margin-right: 10px" />
          <CustomButton title="Ricarica notifiche" @click="ricaricaNotifiche" icon="pi pi-refresh" rounded raised />
        </div>

      </div>
    </template>
<!--    <Column header="Id Task Sprint">-->
<!--      <template #body="slotProps">-->
<!--        <p class="m0">-->
<!--          {{ slotProps.data.idTaskSprint }}-->
<!--        </p>-->
<!--      </template>-->
<!--    </Column>-->
    <Column header="Data creazione" style="width:150px">
      <template #body="slotProps">
        <p>
          {{ slotProps.data.createdAt }}
        </p>
      </template>
    </Column>
    <Column  style="max-width:100px" header="Id Ticket">
      <template #body="slotProps">
        <p class="m0">
          {{ slotProps.data?.idTicket }}
        </p>
      </template>
    </Column>
    <Column style="max-width:150px" header="Esecutore">
      <template #body="slotProps">
        <p class="m0">
          {{ getEsecutore(slotProps?.data?.idCreatedBy) }}
        </p>
      </template>
    </Column>
    <Column header="Stato" style="width:150px">
      <template #body="slotProps">
        <p>
          {{ slotProps.data.vecchioStato }} -> {{ slotProps.data.nuovoStato }}
        </p>
      </template>
    </Column>

    <Column  style="max-width:150px" header="Lavoro">
      <template #body="slotProps">
        <p class="m0">
          {{ slotProps.data?.titoloLavoro }}
        </p>
      </template>
    </Column>
    <Column style="max-width:150px" header="Attività">
      <template #body="slotProps">
        <p class="m0">
          {{ slotProps.data?.titoloAttivita }}
        </p>
      </template>
    </Column>

    <Column style="max-width:150px" field="messaggio" header="Messaggio">
      <template #body="slotProps">
        <p class="messaggio-notifica">
          {{ slotProps.data.messaggio }}
        </p>
      </template>
    </Column>

    <Column header="DOD">
      <template #body="slotProps">
        <p>
          {{ slotProps.data.dodTaskSprint }}
        </p>
      </template>
    </Column>



    <Column header="" style="width: 180px">
      <template #body="slotProps">
        <div class="bottoni-notifica">
          <CustomButton title="Assegna a nuovo PM" class="sposta" icon="pi pi-directions-alt" rounded raised @click="spostaNotifica(slotProps)"> </CustomButton>
          <CustomButton title="Viaualizza dettagli" class="dettaglio" @click="dettaglioNotifica(slotProps)" icon="pi pi-eye" rounded raised />
          <CustomButton title="Approva notifica" class="confirm" @click="approvaNotifica(slotProps)" icon="pi pi-check" rounded raised />
          <CustomButton title="Rifiuta notifica" class="reject" @click="rifiutaNotifica(slotProps)" icon="pi pi-undo" rounded raised />
        </div>

      </template>
    </Column>
    <template #footer> In total there are {{ notifiche ? notifiche.length : 0 }} notifiche. </template>
  </DataTable>


  <CustomDialog v-model:visible="showCambiaManager" modal header="Cambia PM per il TS associato a questa notifica" :style="{ width: '700px' }">
    <div class="row" style="margin-top: 20px">

      <div class="col-12">
        <div class="flex flex-col gap-1">
          <FloatLabel class="w-full md:w-56" variant="on">
            <CustomSelect filter v-model="nuovoManager" :options="esecutori" optionLabel="descrizione" optionValue="id_account" :loading="esecutori.length<=0"   />
            <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->
            <label for="over_label">Manager</label>
          </FloatLabel>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2" style="grid-gap: 40px; display: flex; margin-top: 40px">
      <CustomButton type="button" label="Annulla" severity="secondary" @click="showCambiaManager=false"></CustomButton>
      <CustomButton type="button" label="Conferma" severity="primary" @click="confermaCambioManager"></CustomButton>
    </div>
  </CustomDialog>

  <KModalTutteLeNotifiche></KModalTutteLeNotifiche>
</template>


<script>
import FloatLabel from "primevue/floatlabel";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import CustomButton from 'primevue/button';
import Skeleton from 'primevue/skeleton';
import CustomTextArea from "primevue/textarea";
import CustomDialog from "primevue/dialog";
import CustomSelect from "primevue/select";
import {no} from "vuetify/locale";
import KModalTutteLeNotifiche from "@/views/taskSprint/notifiche/modal-tutte-le-notifiche.vue";


export default {
  name: "tabellaNotifiche",
  components: {KModalTutteLeNotifiche, CustomSelect, CustomDialog, DataTable, Column, CustomButton,FloatLabel  },
  emits: ["show-modal"],

  data() {
    return {
      loaded: false,
      notifiche: [],
      nuovoManager:-1,
      esecutori:[],
      showCambiaManager:false,
      idTaskNotifica:-1
    };
  },
  computed: {
    isLoading() {
      return this.loading;
    }
  },
  mounted() {

  },
  setup() {
  },
  created() {
    this.$store.subscribe(async (mutation, state) => {
      if (mutation.type == 'notificheLoaded') {
        document.title='Dashboard PM - '+mutation.payload.length;
        this.notifiche = [...mutation.payload];
        this.loaded = true;
      }
      if(mutation.type==='notificaGestita' || mutation.type==='notificaRemovedWs'){
        let notifiche=[...this.$store.getters.getNotifiche()];
        document.title='Dashboard PM - '+notifiche.length;
        this.notifiche = [...notifiche];
        this.loaded = true;
      }
    })
  },
  methods: {
    approvaNotifica(notifica) {
      this.$store.dispatch("gestisciNotifica", {
        notifica: { ...notifica.data },
        approvata: true,
        titolo: 'Stai approvando la chiusura del TS ' + notifica.data.idTaskSprint
      });
    },
    rifiutaNotifica(notifica) {
      this.$store.dispatch("gestisciNotifica", {
        notifica: { ...notifica.data },
        approvata: false,
        titolo: 'Stai rifiutando la chiusura del TS ' + notifica.data.idTaskSprint
      });
    },
    dettaglioNotifica(not){
      let notifica=not.data;
      let lavoro={};
      let attivita={};
      if(notifica.idTicketParent && notifica.idTicketParent>0){
        let lav=this.$store.getters.getLavoroTicket(notifica.idTicketParent);
        if(lav && lav.length>0){
          lavoro={
            titolo:lav[0].titolo,
            descrizione:lav[0].descrizione
          }
        }
      }

      if(notifica.idTicket && notifica.idTicket>0){
        let att=this.$store.getters.getTicket(notifica.idTicket);
        if(att && att.length>0){
          attivita={
            titolo:att[0].titolo + ' - '+att[0].id_ticket ,
            descrizione:att[0].descrizione
          }
        }
      }

      let esecutore=this.getEsecutore(notifica.idCreatedBy);
      this.$store.dispatch("showDettaglioNotifica", {
        notifica: { ...notifica },
        lavoro:{...lavoro},
        attivita:{...attivita},
        esecutore:esecutore,
        titolo: 'Dettaglio notifica creata da '+ esecutore +' il '+notifica.createdAt,
      });
    },
    ricaricaNotifiche() {
      //this.loaded = false
      this.$store.dispatch("loadNotifiche");
    },
    getEsecutore(idEsecutore){

      let esecutore=this.$store.getters.getEsecutoriFilter(""+idEsecutore);
      if(!esecutore){
        return ''
      }else{
        return esecutore[0]?.descrizione;
      }
    },

    viewAllNotifiche(){
      this.$store.dispatch("loadAllNotifiche")
    },

    spostaNotifica(not){
      let notifica=not.data;
      this.showCambiaManager=true;
      this.nuovoManager=notifica.idPM+"";
      this.esecutori=this.$store.getters.getEsecutori();
      this.idTaskNotifica=notifica.idTaskSprint;
    },

    confermaCambioManager(){
      this.$store.dispatch("cambiaManagerNotifica", {
        idTaskSprint:this.idTaskNotifica,
        idPmForzato:this.nuovoManager
      });
      this.showCambiaManager=false;
    }
  }
};
</script>